import { CheckCircle, FileIcon } from "lucide-react";
import pdfLogo from "../../../../assets/images/pdfLogo.png";

export default function DocumentSection({ docArray, selectedFiles, setSelectedFiles, isExpanded }) {
    const toggleSelect = (index) => {
        if (selectedFiles.includes(index)) {
            setSelectedFiles(selectedFiles.filter((i) => i !== index));
        } else {
            setSelectedFiles([...selectedFiles, index]);
        }
    };

    return (
        <div className="tw-min-h-screen tw-h-full tw-p-6">
            <div className="tw-max-w-full tw-h-full tw-mx-auto">
                <div className="tw-mb-4 tw-flex tw-justify-between tw-items-center">
                    <h2 className="tw-text-xl tw-font-semibold tw-text-gray-800">Documents and Files</h2>
                    {/* <span className="tw-text-sm tw-text-gray-500">{selectedFiles.size} selected</span> */}
                </div>
                {docArray && docArray.length > 0 ? (
                    <div className={`tw-grid ${isExpanded ? "tw-grid-cols-2" : "tw-grid-cols-1"} tw-gap-4`}>
                        {docArray.map((file, index) => (
                            <FileCard
                                index={index}
                                isExpanded={isExpanded}
                                key={index}
                                file={file}
                                isSelected={selectedFiles.includes(index)}
                                onSelect={toggleSelect}
                            />
                        ))}
                    </div>
                ) : (
                    <div className=" tw-w-full tw-h-full tw-rounded-lg tw-flex tw-justify-center tw-items-center tw-bg-background_color">
                        Files Not Found
                    </div>
                )}
            </div>
        </div>
    );
}

function FileCard({ index, file, isSelected, onSelect, isExpanded }) {
    const extractText = isExpanded ? 100 : 30;

    const displayName =
        file.message.split("/")[file.message.split("/").length - 1].length > extractText
            ? file.message.split("/")[file.message.split("/").length - 1].slice(0, extractText) + "..."
            : file.message.split("/")[file.message.split("/").length - 1];
    return (
        <div className="tw-bg-background_color tw-w-full tw-rounded-lg tw-p-4 tw-shadow-sm tw-flex tw-items-center tw-justify-between tw-mb-2 tw-transition-all tw-duration-200 tw-hover:shadow-md">
            <div className="tw-flex tw-items-center tw-space-x-3">
                {file.message.split(".")[1] === "pdf" ? (
                    <div className=" tw-rounded-lg">
                        <img src={pdfLogo} className="tw-w-6 tw-text-red-500" />
                    </div>
                ) : (
                    <div className=" tw-rounded-lg">
                        <img src={pdfLogo} className="tw-w-6 tw-text-red-500" />
                    </div>
                )}
                <div>
                    <h3 className="tw-text-gray-800 tw-font-medium">{displayName}</h3>
                    <div className="tw-flex tw-items-center tw-space-x-2">
                        <span className="tw-text-sm tw-text-gray-500">{file.size}</span>
                        <span className="tw-text-sm tw-text-gray-700">TYPE:</span>
                        <span className="tw-text-sm tw-text-gray-500 tw-uppercase">{file.message.split(".")[1]?.slice(0, 3)}</span>
                    </div>
                </div>
            </div>
            <span className="tw-text-sm tw-text-gray-500">{file.date}</span>
            <button
                onClick={() => onSelect(index)}
                className={`tw-p-1 tw-rounded-full tw-transition-colors ${
                    isSelected ? "tw-bg-orange-500 tw-text-white" : "tw-text-gray-300 hover:tw-text-gray-400"
                }`}
            >
                <CheckCircle className="tw-w-6 tw-h-6" />
            </button>
        </div>
    );
}
